<div class="cart-item-grouped" *ngFor="let cartItems of groupedCartItems; trackBy: trackBySerialNumber">
  <mat-card fxLayout="column">
    <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
      <div class="spx-body1">
        <strong>{{ cartItems | cartCurrentListGroupHeader | async }}</strong>
      </div>
      <div class="spx-body1" *ngIf="!dontShowPrices">
        {{ 'SHARED.TOTAL_PRICE' | translate }}: <strong>{{ cartItems | cartCurrentListPrice | async }}</strong>
      </div>
    </mat-card-title>
    <mat-card-content>
      <mat-divider></mat-divider>
      <app-table [data]="cartItems" [displayedColumns]="displayColumns" [sort]="sort" matSort #sort="matSort">
        <ng-container matColumnDef="Position">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'SHARED.POSITION' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.Position }}</td>
        </ng-container>
        <ng-container matColumnDef="MaterialNumber">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'SHARED.MATERIAL_NUMBER' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.MaterialNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="CustomerMaterialNumber">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'SHARED.CUSTOMER_MATERIAL_NUMBER' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.CustomerMaterialNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="MaterialDescription">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'SHARED.MATERIAL_DESCRIPTION' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <strong>{{ element.PartName }}</strong>
            <div class="spx-body3">{{ element.CompactText }}</div>
            <div class="spx-body4 descripton-whitespace">{{ element.DetailText }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="Availability">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'SHARED.AVAILABILITY' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <app-cart-current-list-item-availability [availabilities]="availabilities" [currentCartItemId]="element?.Id"></app-cart-current-list-item-availability>
          </td>
        </ng-container>
        <ng-container matColumnDef="Quantity">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'SHARED.QUANTITY' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <app-quantity-selector [quantity]="element.Quantity" (increase)="onIncreaseQuantity(element)" (decrease)="onDecreaseQuantity(element)"></app-quantity-selector>
          </td>
        </ng-container>
        <ng-container matColumnDef="NetWeight">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'NET_WEIGHT' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div fxLayout="row" fxLayoutAlign="end center">
              <span>{{ element.NetWeight }}&nbsp;</span>
              <span>{{ element.NetWeightUnit | weightUnit }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="ListPriceEach">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'SHARED.LIST_PRICE' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <app-cart-current-list-item-price [cartItemId]="element?.Id" [priceType]="'ListPriceEach'"></app-cart-current-list-item-price>
          </td>
        </ng-container>
        <ng-container matColumnDef="NetPriceEach">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'SHARED.UNIT_PRICE' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <app-cart-current-list-item-price [cartItemId]="element?.Id" [priceType]="'NetPriceEach'"></app-cart-current-list-item-price>
          </td>
        </ng-container>
        <ng-container matColumnDef="NetPriceTotal">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'SHARED.TOTAL_PRICE' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <app-cart-current-list-item-price [cartItemId]="element?.Id" [priceType]="'NetPriceTotal'"></app-cart-current-list-item-price>
          </td>
        </ng-container>
        <ng-container matColumnDef="Actions">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'SHARED.ACTIONS' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div fxLayout="row" fxLayoutAlign="end center">
              <spx-button [type]="'mat-stroked-button'" [color]="'primary'" (click)="onClickRemoveItem(element, $event)">
                <spx-icon [filePath]="'assets/icons/icon-trash.svg'"></spx-icon>
              </spx-button>
            </div>
          </td>
        </ng-container>
      </app-table>
    </mat-card-content>
  </mat-card>
</div>
<app-clear-cart-action>
  <spx-button *ngIf="groupedCartItems.length > 0" [type]="'mat-stroked-button'" [color]="'warn'" (click)="resetCart()">
    <spx-icon [name]="'close'"></spx-icon>
    {{ 'CART.ACTIONS.CLEAR_CART_TITLE' | translate }}
  </spx-button>
</app-clear-cart-action>
